// extracted by mini-css-extract-plugin
export var createdDate = "_lo-1";
export var divider = "_lo-2";
export var headerDivider = "_lo-3";
export var messagesCard = "_lo-0";
export var messagesContainer = "_lo-6";
export var messagesContainerWrapper = "_lo-4";
export var showLeftPanelButton = "_lo-8";
export var topButtons = "_lo-7";
export var withPadding = "_lo-5";